import { AppSetting } from 'dependencies/appsettings';
import { ApplicationState } from 'app/types-store';
import { ComplexValue, UserInfo } from 'app/types-shared';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export const createContext = (appState: ApplicationState, props: ConnectedComponentProps) => ({
  caseId: props.hostProps().entityId,
  fieldValue: props.value,
  userInfo: appState.app.userInfo,
  server: AppSetting.ApplicationUrl,
  ...(AppSetting.Integrations as any)
});

export interface TemplateUrlDataContext{
  /**
   * Resolved from hostprops.entityId()
   */
  caseId: number;
  /**
   * UI Engine resolved value for the domain
   */
  fieldValue: string | Date | boolean | ComplexValue<any>;
  /**
   * User profile information from the Store
   */
  userInfo: UserInfo;
  /**
   * ENVIRONMENT_VAR.ApplicationUrl
   *
   * Resolved from explicit appSetting `ApplicationUrl` or if not set, by the ASP.NET runtime
   */
  server: string;
  /**
   * Configured key-value pairs retreived from appSettings key `Integrations`
   */
  integrations: {
    [key:string] : string;
  };
}
